import type { NamePool } from "@/core/types.js";

export const ukNamePool: NamePool = {
  given: {
    male: [
      "Oliver", "George", "Harry", "Jack", "Jacob", "Noah", "Charlie",
      "Muhammad", "Thomas", "Oscar", "William", "James", "Henry", "Alfie",
      "Joshua", "Freddie", "Archie", "Ethan", "Isaac", "Alexander",
      "Edward", "Arthur", "Sebastian", "Daniel", "Samuel", "Leo",
      "Adam", "Benjamin", "Luca", "Elijah", "Harrison", "Mason",
    ],
    female: [
      "Olivia", "Amelia", "Isla", "Ava", "Emily", "Isabella", "Mia",
      "Poppy", "Ella", "Lily", "Sophia", "Evie", "Grace", "Freya",
      "Charlotte", "Emma", "Sophie", "Alice", "Ruby", "Florence",
      "Evelyn", "Daisy", "Millie", "Phoebe", "Harriet", "Imogen",
      "Ellie", "Jasmine", "Abigail", "Matilda", "Rosie", "Chloe",
    ],
  },
  family: [
    "Smith", "Jones", "Williams", "Taylor", "Brown", "Davies", "Evans",
    "Wilson", "Thomas", "Roberts", "Johnson", "Lewis", "Walker", "Robinson",
    "Wood", "Thompson", "White", "Watson", "Jackson", "Wright",
    "Green", "Harris", "Cooper", "King", "Lee", "Martin", "Clarke",
    "James", "Morgan", "Hughes", "Edwards", "Hill", "Moore", "Clark",
    "Harrison", "Scott", "Young", "Morris", "Hall", "Ward", "Turner",
    "Carter", "Phillips", "Mitchell", "Patel", "Adams", "Campbell",
    "Anderson", "Allen", "Cook",
  ],
};
